var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "airplane",
  "use": "airplane-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"airplane\">\n    <path d=\"m99 1l-98 55 29 10 38-32-30 35v30l15.5-24.5 22.5 7.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/airplane.icon
// module id = 61
// module chunks = 168707334958949